import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { StyledTeamsFilters } from "./teams-filters.scss";
import Dropdown from "../dropdown/dropdown";
import teams from "./teams.json";
import { useCallback, useMemo } from "react";
const TEAMS_DROPDOWN_TITLE = "Choose your favorite team";
const TeamsFilters = ({ onTeamChange, selectedTeamId })=>{
    const reset = useCallback(()=>onTeamChange(null), [
        onTeamChange
    ]);
    const handleDropdownOptionKeyPress = (event, onChangeFunc)=>event.key === "Enter" && onChangeFunc();
    const selectedTeam = useMemo(()=>teams.find((team)=>team.id === selectedTeamId), [
        selectedTeamId
    ]);
    const itemRenderer = (team)=>/*#__PURE__*/ _jsxs("a", {
            tabIndex: "0",
            className: classnames("dropdown-item", "team-item", {
                "is-active": (selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.id) === team.id
            }),
            onClick: ()=>onTeamChange(team.id),
            onKeyPress: (event)=>handleDropdownOptionKeyPress(event, ()=>onTeamChange(team.id)),
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "colored-ribbon",
                    style: {
                        background: team.color
                    }
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "details",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "team",
                            children: team.name
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "description",
                            children: team.description
                        })
                    ]
                })
            ]
        }, team.id);
    return /*#__PURE__*/ _jsx(StyledTeamsFilters, {
        children: /*#__PURE__*/ _jsx(Dropdown, {
            reset: reset,
            dropdownTitle: TEAMS_DROPDOWN_TITLE,
            title: "All Teams",
            items: teams,
            selectedItem: selectedTeam,
            itemRenderer: itemRenderer
        })
    });
};
export default TeamsFilters;
